import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Typography, Button, List, ListItem, ListItemText} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import {useHistory} from "react-router-dom";
import formInitialValues from '../../../Emision/CombinadoForm/Checkout/FormModel/formInitialValues';
import Loading from "../../../../Loading";
import axios from "axios";
import UserContext from "../../../../../context/UserContext";
import CotizarContext from "../../../../../context/CotizarContext";

const FileDownload = require('js-file-download');

const useStyles = makeStyles((theme) => ({
    buttons: {
        display: 'flex',
        justifyContent: 'center'
    },
    buttonContained: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        background: "#BB0D66",
        padding: "6px 12px",
        marginLeft: "4px",
        marginRight: "4px",
        textDecoration: "none",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
        '&:hover': {
            boxShadow: 'none',
        },
    },
    textContainer: {
        backgroundColor: '#ffb25e',
        padding: theme.spacing(1),
        borderRadius: '10%',
        alignItems: 'center',
    },
    outStandardText: {
        align: 'center',
        fontSize: 10
    }
}));

function CotizacionSuccess(props) {
    const classes = useStyles();
    const {finalValues, cotizacionResponse} = props;
    const [dictCoberturas, setDictCoberturas] = useState(null);
    const {coberturasInfo, coveragesToFilter} = useContext(CotizarContext);
    const history = useHistory();
    //This will be used to add an extra step on the Emision Form
    let additionalStep = false;
    const coveragesRequiringDetails = ["49", "48", "26"]

    const handleEmision = () => {
        let emisionValues = formInitialValues;

        emisionValues.coberturas = finalValues.coberturas.sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
        emisionValues.clientes[0].codigosLocalidad = finalValues.codigosLocalidad;
        emisionValues.descuentoEspecial = finalValues.descuentoEspecial;
        emisionValues.tamanioVivienda = finalValues.tamanioVivienda;
        emisionValues.tipoVivienda = finalValues.tipoVivienda;
        emisionValues.origen = finalValues.origen;
        emisionValues.afinidad = finalValues.afinidad;
        emisionValues.premium = cotizacionResponse.premioMensual;
        emisionValues.clientes[0].nombre = finalValues.nombre;
        emisionValues.clientes[0].apellido = finalValues.apellido;
        if (finalValues.dni !== undefined)
            emisionValues.clientes[0].dni = finalValues.dni.toString();
        emisionValues.clientes[0].email = finalValues.email;
        emisionValues.clientes[0].codigoArea = finalValues.codigoArea;
        emisionValues.clientes[0].telefono = finalValues.telefono;

        emisionValues.vigenciaDesde = finalValues.fechaCotizacion;

        finalValues.coberturas.map((cob) => {
            if (coveragesRequiringDetails.includes(cob.numeroCobertura))
                additionalStep = true
        })

        emisionValues.additionalStep = additionalStep
        emisionValues.deducible = finalValues.deducible;

        history.push({
            pathname: "/u/emitir/combinado",
            state: {
                emisionValues: emisionValues,
                idCotizacion: cotizacionResponse["cotizacionId"]
            }
        })
    };

    const {userName, userPicture, userId, userPhone, userProvince, userMail} = useContext(UserContext)

    function imprimir() {
        const viviendasDict = {
            '1021': 'Casa de ocupación permanente',
            '1022': 'Departamento de ocupación permanente',
            '1023': 'Vivienda en barrio cerrado',
            '1024': 'Vivienda/Departamento de ocupación transitoria',
        };

        let jsonData = {
            "num_cotizacion": cotizacionResponse['cotizacionId'],
            "codigosLocalidad": finalValues['codigosLocalidad'],
            "tamanioVivienda": finalValues['tamanioVivienda'],
            "tipoVivienda": viviendasDict[finalValues['tipoVivienda']],
            "tipoViviendaPDF": finalValues['tipoVivienda'],
            'fecha': finalValues['fechaCotizacion'],
            'cod_postal': cotizacionResponse['codigoPostal'],
            "cuota_mensual": cotizacionResponse['premioMensual'],
            'img_src': userPicture,
            'nombre': userName,
            'telefono': userPhone,
            'mail': userMail,
            'provincia': userProvince,
            'id_Auth': userId,
            'nombre_cliente': finalValues.nombre !== undefined ? `${finalValues.nombre} ${finalValues.apellido}` : null,
            'dni_cliente': finalValues.dni !== undefined ? finalValues.dni : null,
            'img_afinidad': finalValues.img_afinidad,
            'deducible': finalValues.deducible
        }

        let dict = []
        let vals
        finalValues.coberturas.forEach(value => {
            vals = {}
            vals['id'] = value['numeroCobertura']
            vals['sumaAsegurada'] = value["sumaAsegurada"]
            dict.push(vals)
        })
        jsonData["dictionary"] = dict

        axios.post(process.env.REACT_APP_BACK_SERVER + '/templateCombinadoAffinity', jsonData, {responseType: 'blob'})
            .then((response) => {
                FileDownload(response.data, 'cotizacion.pdf');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function currencyFormat(numString) {
        numString = numString.toString().replace(/\./g, "")
        numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return numString
    }

    useEffect(() => {
        let dict = {};
        coberturasInfo.map((item) =>
            dict[item.NumeroCobertura] = {
                descripcion: item.Descripcion,
                descripcionCompleta: item.DescripcionCompleta,
                obligatorio: item.Obligatorio
            });

        setDictCoberturas(dict)
    }, []);


    if (!dictCoberturas) return <Loading/>;
    return (
        <React.Fragment>
            <Fragment>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'Montserrat', fontWeight: 600}}>
                    Resumen de Cotización
                </Typography>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'Montserrat'}}>
                    Cuota Mensual: ${cotizacionResponse['premioMensual'].toFixed(2)}
                </Typography>
                <Typography variant="subtitle1" gutterBottom style={{fontFamily: 'Nunito'}}>
                    Detalle Coberturas:
                </Typography>
                <List dense>
                    {cotizacionResponse['detalleCoberturas']["obligatorias"].filter(
                        cov => !coveragesToFilter.includes(cov['numeroCobertura'])
                    ).map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText
                                primary={dictCoberturas[item.numeroCobertura].descripcion}
                                secondary={`Suma Asegurada: $ ${currencyFormat(item.sumaAsegurada)}`}
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="subtitle1" gutterBottom style={{
                    fontFamily: 'Nunito',
                    display: cotizacionResponse['detalleCoberturas']["adicionales"].length === 0 && "None"
                }}>
                    Adicionales:
                </Typography>
                <List dense>
                    {cotizacionResponse['detalleCoberturas']["adicionales"].map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText
                                primary={dictCoberturas[item.numeroCobertura].descripcion}
                                secondary={`Suma Asegurada: $ ${currencyFormat(item.sumaAsegurada)}`}
                            />
                        </ListItem>
                    ))}
                </List>


                <div className={classes.buttons}>
                    <Button className={classes.buttonContained} onClick={() => imprimir()}>
                        Imprimir
                    </Button>
                    <Button className={classes.buttonContained}
                            onClick={handleEmision}
                    >
                        Emitir
                    </Button>
                </div>
            </Fragment>
        </React.Fragment>
    );
}

export default CotizacionSuccess;
